/** Ids that tie a T2 route tab to the panel it controls (`aria-controls` / `aria-labelledby`). */
export const recordTabId = (idBase: string, id: string) => `${idBase}-tab-${id}`;
export const recordPanelId = (idBase: string) => `${idBase}-panel`;
